import { useRoute } from '@nuxtjs/composition-api';
import * as categoryJSON from '../../../constants/categories.json';

function isNumeric(str) {
  if (typeof str !== 'string') return false;
  return !isNaN(str) && !isNaN(parseFloat(str));
}

export const getActiveRouteKey = () => {
  const route = useRoute();
  const subOrPagination = route.value.params?.subOrPagination;
  const routeName = route.value.name?.split('___')[0]; // i18n prefix remove
  const routeKey = isNumeric(subOrPagination) ? routeName : route.value.path;
  return routeKey;
};

export const getParentRouteKey = (category) => {
  const routeKey = getActiveRouteKey();
  const routeKeySplit = routeKey.split('/');
  if (category?.ancestors?.length) {
    return category.ancestors[0];
  } else {
    return routeKeySplit.length > 2 ? routeKeySplit.slice(0, -1).join('/') : null;
  }
};

export const getCategoryInfo = () => {
  const categories = categoryJSON.categories;
  const routeKey = getActiveRouteKey();
  const category = categories[routeKey];
  const parentKey = getParentRouteKey(category);
  if (category && parentKey) {
    category.parent = categories[parentKey];
  }
  return category;
};

export const getCategoryInfoByPath = (path) => {
  const categories = categoryJSON.categories;
  return categories[path] || {};
};

export const getCategoryPageNumber = () => {
  const route = useRoute();
  const subOrPagination = route.value.params?.subOrPagination;
  return isNumeric(subOrPagination) ? Number(subOrPagination) : 1;
};

export const getCategorySiblings = (path) => {
  const category = getCategoryInfoByPath(path);
  if (!category.ancestors || category.ancestors.length === 0) {
    return [];
  }
  const parentData = getCategoryInfoByPath(category.ancestors[category.ancestors.length - 1]);
  return parentData.subs;
};

export const isVideoCategory = (id) => {
  const categoryIds = categoryJSON.constants?.ids;
  return id === categoryIds.video;
};

export const isTestCategory = (id) => {
  const categoryIds = categoryJSON.constants?.ids;
  return id === categoryIds.test;
};
